class CultureOceanSlider {
  constructor(target) {
    this.target = target
    this.$container = $('body')
    if(this.$container.hasClass('template-landing-partager')) {
      this.initialize()
    }
    if (this.$container.find('.post-type__filters').length) {
      this.initialize()
    }
  }

  initSlider($el, params) {
    $el.slick(params)
    this.handleFilter($el)
  }

  handleFilter($el) {
    const $parent = this.$container.find('.post-type__filters')
    const $filters = $parent.find('input[name="article-slider"]')
    $filters.on('change', e => {
      e.preventDefault()
      const value = $parent.find('input[name="article-slider"]:checked').val()
      if (value === 'all') {
        $el.slick('slickUnfilter')
      } else {
        $el.slick('slickUnfilter')
        $el.slick('slickFilter', `.${value}`)
      }
    })
  }

  initialize() {
    this.$container.find(this.target).each((_, el) => {
      const $el = $(el)
      let params = $el.data('slider-params');
      if (!params) {
        params = {};
      }
      params.prevArrow = '<button class="slick-arrow slick-prev"><i class="icon icon-arrow"></i></button>';
      params.nextArrow = '<button class="slick-arrow slick-next"><i class="icon icon-arrow"></i></span></button>';
      this.initSlider($el, params);
    })
  }
}

export default CultureOceanSlider;



// WEBPACK FOOTER //
// ./scripts/components/CultureOceanSlider.js